import type PlantModel from "Models/Plant";
import type VarietyModel from "Models/Variety";

export const formatPlantName = (
  name: string | undefined,
  varietyName?: string,
): string => {
  if (!name) return "";
  return varietyName ? `${name} (${varietyName})` : name;
};

export const getPlantDisplayName = (
  plant: PlantModel | undefined,
  varieties: readonly VarietyModel[],
): string => {
  const variety = varieties.find((item) => item._id === plant?.varietyId);
  return formatPlantName(plant?.name, variety?.name);
};
